export default __webpack_public_path__ + "static/media/chuvoso.f37d9486.svg";